module.exports = __webpack_public_path__ + "img/img_05.00266fe6.jpg";